export const onInitService = ({ getConfig, setContext, createExtension }) => {
  setContext(
    "one.vapor.theme.name",
    getConfig("one.vapor.theme.name", "vapor-light")
  );

  setContext(
    "one.vapor.theme.url.param",
    getConfig("one.vapor.theme.url.param", "theme")
  );

  setContext(
    "one.vapor.theme.session.param",
    getConfig("one.vapor.theme.session.param", "theme")
  );
};
